import { Button, Form, Input, Modal } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { Actions } from "../../shared/constant";
import validateMessages from "../../utils/validate";
import {
  createPlatform,
  editPlatform,
  resetPlatform,
} from "../../redux/actions/platformActions";

interface ModalFormProps {
  visible: boolean;
  onCancel: () => void;
  callEffect: () => void;
  mode: string;
  editData: any;
}

const PlatformModalForm = ({
  visible,
  onCancel,
  callEffect,
  mode,
  editData,
}: ModalFormProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { pending, fulfilled } = useSelector(
    (state: RootState) => state.platform,
  );

  useEffect(() => {
    if (mode === Actions.EDIT) {
      form.setFieldsValue({ name: editData.name });
    }
  }, [editData]);

  useEffect(() => {
    /* Create and Edit success */
    if (mode === Actions.CREATE || mode === Actions.EDIT) {
      if (fulfilled) {
        onCancel();
        callEffect();
        dispatch(resetPlatform());
      }
    }
  }, [pending]);

  const onOk = async () => {
    try {
      await form.validateFields();
    } catch (errorInfo) {
      return;
    }

    const formFields = form.getFieldsValue(true);
    if (mode === Actions.CREATE) dispatch(createPlatform(formFields));
    if (mode === Actions.EDIT) dispatch(editPlatform(editData.id, formFields));
  };

  const afterClose = () => {
    form.resetFields();
  };

  return (
    <Modal
      visible={visible}
      title={`${mode === Actions.CREATE ? "Create" : "Edit"} Platform`}
      centered
      width={740}
      maskClosable={false}
      onOk={onOk}
      onCancel={onCancel}
      afterClose={afterClose}
      destroyOnClose
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={pending as boolean}
          onClick={onOk}
        >
          Save
        </Button>,
      ]}
    >
      <div className="mx-6 mt-6 mb-[26px]">
        <Form
          form={form}
          layout="vertical"
          name="PlatformForm"
          validateMessages={validateMessages}
        >
          <Form.Item
            name="name"
            label="Platform Name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default PlatformModalForm;
